export default __webpack_public_path__ + "static/brass-texture-green-19757355c25bfe97f444e570fc4501a1.png";